import { containsFiles } from '~helper/dataTransfer'
import store from '../store'

import {
  increaseDocumentDragCounter,
  decreaseDocumentDragCounter,
} from '~store/modules/documents/mutationTypes.js'

const appContainer = document.querySelector('body')
let dragCounter = 0

const hasNoActiveOverlay = () => {
  return document.querySelector('.v-overlay') === null
}

/**
 * Triggered if user drags something into
 * the documents viewport.
 */
appContainer.addEventListener(
  'dragenter',
  function (e) {
    if (containsFiles(e.dataTransfer) && hasNoActiveOverlay()) {
      e.preventDefault()
      if (dragCounter === 0) {
        store.commit(increaseDocumentDragCounter)
      }

      dragCounter++
    }
  },
  false
)

/**
 * Triggered if user stops dragging something into
 * the documents viewport.
 */
appContainer.addEventListener(
  'dragleave',
  function (e) {
    if (containsFiles(e.dataTransfer) && hasNoActiveOverlay()) {
      e.preventDefault()
      if (dragCounter === 1) {
        store.commit(decreaseDocumentDragCounter)
      }

      dragCounter--
    }
  },
  false
)

/**
 * Triggered if user stops dragging something into
 * the documents viewport.
 */
appContainer.addEventListener(
  'drop',
  function () {
    dragCounter = 0
  },
  false
)
